import { useCallback, useState } from "react";

import type { AirHostPricePlan } from "@/lib/gql/__generated__/graphql";

import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { SiteControllerSettingAirHostPricePLan_SettingPage_Query } from "../schema";

export const useAirHostPricePlanQuery = ({
	hotelID,
	airHostApiAccessToken,
	airHostPartnerID,
	airHostPropertyID,
}: {
	hotelID: string;
	airHostPartnerID: string;
	airHostApiAccessToken: string;
	airHostPropertyID: string;
}) => {
	const { data, refetch } = useCustomSuspenseQuery(
		SiteControllerSettingAirHostPricePLan_SettingPage_Query,
		{
			variables: { hotelID },
		},
		Boolean(!airHostPartnerID || !airHostApiAccessToken || !airHostPropertyID),
	);

	const onRefetchAirHostPricePlan = useCallback(
		async ({ hotelID }: { hotelID: string }) => {
			const res = await refetch({
				hotelID,
			});

			return res.data;
		},
		[refetch],
	);

	const [pricePlanData, setPricePlanData] = useState<AirHostPricePlan[]>(
		data?.siteControllerSettingAirHostPricePlanDataFetch.airHostPricePlanData.map((item) => ({
			airHostPricePlanID: item.airHostPricePlanID,
			airHostPricePlanName: item.airHostPricePlanName,
			airHostRoomTypeID: item.airHostRoomTypeID,
			airHostRoomCheckInTime: item.airHostRoomCheckInTime,
			airHostRoomCheckOutTime: item.airHostRoomCheckOutTime,
		})) ?? [],
	);

	const onSetPricePlanData = useCallback((pricePlanData: AirHostPricePlan[]) => {
		setPricePlanData(pricePlanData);
	}, []);

	return { onRefetchAirHostPricePlan, pricePlanData, onSetPricePlanData };
};
